/**
 * @generated SignedSource<<a001b9f9589b56b9c80a64326bacb32b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespContainer_itemSearch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarButtons_itemSearch">;
  readonly " $fragmentType": "PdpRespContainer_itemSearch";
};
export type PdpRespContainer_itemSearch$key = {
  readonly " $data"?: PdpRespContainer_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespContainer_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespContainer_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarButtons_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "5e2cd0709aa718f0081368d09c043a3a";

export default node;
